<template>
  <div>
    <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs"
      :form-fields="formFields" :permission="permission" />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'UniPromotionTaskDetail',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'uniPromotionTaskDetail:add',
        update: 'uniPromotionTaskDetail:update',
        delete: 'uniPromotionTaskDetail:delete',
        deleteBatch: 'uniPromotionTaskDetail:deleteBatch'
      },
      url: {
        get: '/uniPromotionTaskDetail/listByCondition',
        add: '/uniPromotionTaskDetail/add',
        update: '/uniPromotionTaskDetail/update',
        delete: '/uniPromotionTaskDetail/delete',
        delete_batch: '/uniPromotionTaskDetail/deleteBatch',
        status: '/uniPromotionTaskDetail/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',  // 字段名
        label: 'agentId',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'name',  // 字段名
        label: '计划名称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'advertiserId',  // 字段名
        label: '广告主ID',  // 字段显示名称
        sort: false,  // 是否排序
      selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'aweMeId',  // 字段名
        label: '抖音号',  // 字段显示名称
        sort: false,  // 是否排序
        // selectUrl: '/launchTheProduct/getAllIDInfo',
        // selectData: [],
        show: false,
      }, {
        field: 'adId',  // 字段名
        label: '计划ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'goodsNum',  // 字段名
        label: '商品数量',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'budget',  // 字段名
        label: '预算',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'roi2Goal',  // 字段名
        label: '整体ROI目标',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'status',  // 字段名
        label: '计划状态',  // 字段显示名称
        sort: false,  // 是否排序
        selectUrl: '/uniPromotion/ad-status',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'taskStatus',  // 字段名
        label: '任务状态',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 0,
          name: '创建失败  '
        }, {
          id: 1,
          name: '创建中'
        }, {
          id: 2,
          name: '创建成功'
        }],
      }, {
        field: 'msg',  // 字段名
        label: '失败原因',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              { required: true, message: 'agentId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'name',  // 字段名
            label: 'name',  // 字段显示名称
            type: 'input',
            placeholder: '请输入name',
            rules: [
              { required: true, message: 'name不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'advertiserId',  // 字段名
            label: 'advertiserId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入advertiserId',
            rules: [
              { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'aweMeId',  // 字段名
            label: 'aweMeId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入aweMeId',
            rules: [
              { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'adId',  // 字段名
            label: 'adId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入adId',
            rules: [
              { required: true, message: 'adId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'goodsNum',  // 字段名
            label: 'goodsNum',  // 字段显示名称
            type: 'input',
            placeholder: '请输入goodsNum',
            rules: [
              { required: true, message: 'goodsNum不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'budget',  // 字段名
            label: 'budget',  // 字段显示名称
            type: 'input',
            placeholder: '请输入budget',
            rules: [
              { required: true, message: 'budget不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'roi2Goal',  // 字段名
            label: 'roi2Goal',  // 字段显示名称
            type: 'input',
            placeholder: '请输入roi2Goal',
            rules: [
              { required: true, message: 'roi2Goal不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              { required: true, message: 'status不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'taskStatus',  // 字段名
            label: 'taskStatus',  // 字段显示名称
            type: 'input',
            placeholder: '请输入taskStatus',
            rules: [
              { required: true, message: 'taskStatus不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'msg',  // 字段名
            label: 'msg',  // 字段显示名称
            type: 'input',
            placeholder: '请输入msg',
            rules: [
              { required: true, message: 'msg不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped></style>
